import { Box } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useCallback } from 'react';
import { ByUnitsUnitDetailPanelContent } from './ByUnitsUnitDetailPanelContent';
import { supplierDataGridSx } from './supplierDataGridStyles';
import { SPEND_COLUMNS } from './SupplierDataGridUtils';

export function ByUnitsUnitGroupDetailPanelContent({
  row,
  updateSupplierStatus,
  isEdit
}) {
  const unitColumns = [
    {
      field: 'name',
      headerName: 'Unit',
      width: 600
    },
    ...SPEND_COLUMNS
  ];

  const getUnitDetailPanelContent = useCallback(
    ({ row }) => (
      <ByUnitsUnitDetailPanelContent
        updateSupplierStatus={updateSupplierStatus}
        row={row}
        isEdit={isEdit}
      />
    ),
    [isEdit]
  );

  const getUnitPanelHeight = useCallback(() => 'auto', []);

  return (
    <Box sx={{ ml: 12 }}>
      <DataGridPro
        density="compact"
        slots={{
          detailPanelExpandIcon: () => <fuel-icon name="content_expand" />,
          detailPanelCollapseIcon: () => <fuel-icon name="content_collapse" />
        }}
        columns={unitColumns}
        rows={row.unitsSpend}
        hideFooter
        getDetailPanelHeight={getUnitPanelHeight}
        getDetailPanelContent={getUnitDetailPanelContent}
        sx={supplierDataGridSx}
      />
    </Box>
  );
}
